// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__28sGq","options":"AnswerScale_options__3wV8K","selected":"AnswerScale_selected__1ykce"};